export const colors = {
  cream:     '#FAF6F0',
  creamMid:  '#F0E5D4',
  creamDark: '#E2D0BB',
  terra:     '#C07848',
  terraDk:   '#8A5028',
  ink:       '#1E1208',
  inkMid:    '#5A3820',
  inkLight:  '#9A7858',
  white:     '#FFFDF9',

  // legacy aliases kept for compatibility
  primary:   '#C07848',
  secondary: '#FFFDF9',
  tertiary:  '#9A7858',
  quaternary:'#1E1208',
  quinary:   '#F0E5D4',
}
